import axios from 'axios';
import { Field, Form, Formik } from 'formik';
import { DateTime } from 'luxon';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../../SharedComponents/Button/Button';
import SelectV2 from '../../SharedComponents/Inputs/components/SelectV2';
import Notification from '../../SharedComponents/Notification';

export default function SubmitStatus(props) {
  const params = useParams();
  const id = parseInt(params.id);
  const queryClient = useQueryClient();

  const followupData = queryClient.getQueryData(`followup`);
  const requestStatusData = queryClient.getQueryData(`requestStatus`);

  const mutationFunction = async (e) => {
    const { data } = await axios.post(`UserAccount/AddRequestPosition`, e);
    return data;
  };

  const mutation = useMutation(mutationFunction, {
    onSuccess: (data) => {
      toast(<Notification message={data.message} />);

      queryClient.invalidateQueries([`singleTalab-${id}`]);
      queryClient.invalidateQueries([`signleTalabRquestPositions-${id}`]);
    },
  });

  const onSubmit = (e, { resetForm }) => {
    mutation.mutate(e);
    resetForm();
  };

  const initialValues = {
    positionDateString: DateTime.now().toISODate(),
    notes: '',
    internalNotes: '',
    requestFollowupId: followupData ? followupData?.data[0].id : 1,
    requestStatusId: requestStatusData ? requestStatusData?.data[0].id : 1,
    newRequestId: id,
  };
  return (
    <div className="bg-[#fff] border border-gray-100 border-r-4 print:hidden  border-r-[#84cc16] p-4 mt-4 shadow-md">
      <Formik onSubmit={onSubmit} initialValues={initialValues}>
        {({ values, errors, resetForm }) => {
          return (
            <Form>
              <div className="grid grid-cols-3 gap-6 mt-4">
                <div className="">
                  <label className={`flex  flex-col justify-start rtl:justify-end space-y-2`}>
                    <span className={`font-bold text-base text-right rtl:text-right `}> تاريخ الموقف</span>
                    <Field type="date" name="positionDateString" className="border rounded py-2 px-3" />
                  </label>
                </div>

                <div className="">
                  <label className={`flex flex-col justify-start rtl:justify-end space-y-2`}>
                    <span className={`font-bold text-base text-right rtl:text-right  `}> حالة الطلب *</span>
                    <SelectV2
                      selectList={requestStatusData?.data}
                      loading={requestStatusData === undefined}
                      wrapperClass="mt-0"
                      errors={errors}
                      name="requestStatusId"
                    />
                  </label>
                </div>
                <div className="">
                  <label className={`flex flex-col justify-start rtl:justify-end space-y-2`}>
                    <span className={`font-bold text-base text-right rtl:text-right `}> جهة المتابعة *</span>
                    <SelectV2
                      selectList={followupData?.data}
                      loading={followupData === undefined}
                      wrapperClass="mt-0"
                      errors={errors}
                      name="requestFollowupId"
                    />
                  </label>
                </div>
                <div className="col-span-3">
                  <label className={`flex  flex-col justify-start rtl:justify-end space-y-2`}>
                    <span className={`font-bold text-base text-right rtl:text-right `}> ملاحظات</span>
                    <Field name="notes" className="border rounded py-2 px-3" as="textarea" />
                  </label>
                </div>
                <div className="col-span-3">
                  <label className={`flex  flex-col justify-start rtl:justify-end space-y-2`}>
                    <span className={`font-bold text-base text-right rtl:text-right `}>ملاحظات خاصة بالاتحاد</span>
                    <Field name="internalNotes" className="border rounded py-2 px-3" as="textarea" />
                  </label>
                </div>
                <div className="flex space-x-2 rtl:space-x-reverse">
                  <div>
                    <Button
                      type="submit"
                      loading={mutation.isLoading}
                      disabled={mutation.isLoading}
                      className="px-10"
                    />
                  </div>
                  <div>
                    <Button
                      text="الغاء"
                      onClick={() => {
                        resetForm();
                      }}
                      className="bg-red-500 hover:bg-red-400 px-10"
                    />
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
